<template>
  <div class="insurance-list-container">
    <div class="card-container">
      <!-- 查询区域 -->
      <div class="query-section">
        <!-- 保单号 -->
        <div class="query-item">
          <span class="query-label">保单号</span>
          <el-input
            v-model="policyNo"
            placeholder="请输入保单号"
            style="width: 300px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 人员名称 -->
        <div class="query-item">
          <span class="query-label">人员名称</span>
          <el-input
            v-model="insuredName"
            placeholder="请输入人员名称"
            style="width: 300px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 证件号码 -->
        <div class="query-item">
          <span class="query-label">证件号码</span>
          <el-input
            v-model="insuredIdCard"
            placeholder="请输入证件号码"
            style="width: 300px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 工种 -->
        <div class="query-item">
          <span class="query-label">工种</span>
          <el-select
            clearable
            v-model="insuredWorkType"
            placeholder="请选择工种"
            style="width: 300px;"
          >
            <el-option
              v-for="item in workTypes"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>

        <div class="query-buttons">
          <el-button type="primary" @click="fetchInsuranceList" class="query-button">查询</el-button>
        </div>
      </div>

      <!-- 表格区域 -->
      <el-table :data="insuranceList" :fit="true" border v-loading="loading" :loading-text="'正在加载数据...'">
        <el-table-column prop="policyNo" label="保单号"></el-table-column>
        <el-table-column prop="insuredName" label="人员名称"></el-table-column>
        <el-table-column prop="insuredIdCard" label="证件号码"></el-table-column>
        <el-table-column prop="insuredAge" label="年龄"></el-table-column>
        <el-table-column prop="insuredWorkType" label="工种"></el-table-column>
        <el-table-column prop="endorseFlag" label="批增/减"></el-table-column>
        <el-table-column prop="correctionStartDate" label="批改生效时间"></el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {service} from '../../utils/axios'
import {getToken} from '../../utils/auth'

export default {
  name: 'anDeCorrect',
  data () {
    return {
      workTypes: [
        '核算员', '保洁员', '保安员', '拣货员', '仓管员',
        '生产辅助工', '产线工人', '叉车司机', '装卸工'
      ],
      policyNo: '',
      insuredName: '',
      insuredIdCard: '',
      insuredWorkType: '',
      policyStatus: '',
      loading: false, // 添加加载状态标记
      insuranceList: [], // 投保列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0 // 总条数
    }
  },
  methods: {
    // 获取投保列表数据
    async fetchInsuranceList () {
      this.loading = true // 添加加载状态标记
      // TODO: 对接后端接口
      try {
        const params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          policyNo: this.policyNo,
          insuredName: this.insuredName,
          insuredIdCard: this.insuredIdCard,
          insuredWorkType: this.insuredWorkType,
          policyStatus: this.policyStatus
        }
        const res = await service.get('/adCorrect/list', {
          params: params, // 将参数正确放入params属性
          headers: {
            'x-access-token': getToken() || '' // 确保token存在
          },
          timeout: 100000
        })
        console.log(res.result)
        if (res.success) {
          console.log(res.result)
          this.insuranceList = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error('数据获取失败')
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('登录过期，请重新登录')
          this.$router.push({path: '/login'})
        }
        console.error('接口请求异常:', error)
        this.$message.error('数据加载失败')
      } finally {
        this.loading = false // 结束加载，无论成功失败
      }
    },
    // 每页条数变化
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchInsuranceList()
    },
    // 当前页码变化
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchInsuranceList()
    }
  },
  created () {
    // 页面加载时获取列表数据
    this.fetchInsuranceList()
  }
}
</script>

<style scoped>

.query-section {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  padding: 15px;
  background-color: #f9fafc;
  border-radius: 6px;
}

.query-item {
  display: flex;
  align-items: center;
}

.query-label {
  width: 80px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  font-size: 14px;
}

.query-buttons {
  margin-left: auto;
}

.insurance-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.query-button {
  height: 40px;
}

.insurance-table {
  margin-bottom: 20px;
  border-radius: 6px;
  overflow: hidden;
}

.insurance-table /deep/ .el-table__row:hover {
  background-color: #f5f7fa;
}

.insurance-table /deep/ .el-table th {
  background-color: #f5f7fa;
  font-weight: 500;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.download-link {
  color: #409EFF;
  text-decoration: none;
}

.download-link:hover {
  text-decoration: underline;
}

::v-deep .el-input-group__prepend {
  display: none;
}

::v-deep .el-input__inner {
  border-left: none;
}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/anDeCorrect.vue